export default __webpack_public_path__ + "static/media/co2_ukghg_map_natural_20170101T00.8615fcfb.png";